// Author Lin
// Date 2021-06-28 10:31:33

import * as model from "@/model/sithMes/inventory/SithMesInventoryPackageMaterialModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryPackageMaterial(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'packageFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'unpackingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'packageVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'unpackingVo'
    })
    .buildStore()
